<script setup lang="ts">
const companyLogo = import.meta.env.VITE_COMPANY_LOGO;
const logoRtlLight = computed(() => {
  return `/images/logos/${companyLogo}/logo-light-rtl.png`;
});

const props = defineProps({
  width: {
    type: String,
    default: '110px',
  },
  height: {
    type: String,
    default: 'auto',
  },
})
</script>

<template>
  <div class="logo">
    <NuxtLink to="/">
      <img :src="logoRtlLight" :style="{'width': width , 'height': height}" :alt="$t('Home')" />
    </NuxtLink>
  </div>
</template>
